import IconButton from '@mui/material/IconButton'
import { styled } from '@mui/material/styles'

interface ButtonProps {
  isActive: boolean
}

export default styled(IconButton, { shouldForwardProp: (prop) => prop !== 'isActive' })<ButtonProps>(({ isActive, theme }) => ({
  position: 'absolute',
  color: theme.palette.primary.contrastText,
  backgroundColor: 'rgba(71,85,105,0.5)',
  padding: '2px',
  display: isActive ? 'inline-flex' : 'none',
  '&:hover': {
    display: 'inline-flex'
  }
}))
